module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "CardDetails mb-4",
    attrs: {
      "text": "",
      "elevation": "0"
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0 pb-4"
  }, [_vm._v("\n    " + _vm._s(_vm.title) + " " + _vm._s(_vm.$t("CardDetails.lotDetails")) + " \"" + _vm._s(_vm.location.name) + "\"\n    "), _c('v-tooltip', {
    attrs: {
      "right": "",
      "nudge-bottom": "55"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-icon', _vm._g({
          staticClass: "ml-2",
          attrs: {
            "size": 18,
            "color": "#757575"
          }
        }, on), [_vm._v("info_outline")])]
      }
    }])
  }, [_vm._v(" "), _vm._l((_vm.getDescriptionKeys), function(key) {
    return _c('p', {
      key: key,
      staticClass: "mb-0"
    }, [_c('span', {
      staticStyle: {
        "font-weight": "300",
        "font-size": "14px !important"
      }
    }, [_vm._v(_vm._s(_vm.descriptionLabels[key]) + ":")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-weight": "400",
        "font-size": "14px !important"
      }
    }, [_vm._v(_vm._s(_vm.getDescriptionItem(key)))])])
  })], 2)], 1), _vm._v(" "), _c('v-container', {
    staticClass: "Content d-flex pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-row', {
    staticClass: "Data fill-height",
    attrs: {
      "dense": ""
    }
  }, _vm._l((_vm.getVisualInfoItemsKeys), function(key) {
    return _c('v-flex', {
      key: key,
      staticClass: "DataItem pr-2 d-flex",
      class: key === 'application_rate' ? 'xs5' : (key === 'num_faults' ? 'xs3' : 'xs4')
    }, [_c('div', [_c('v-avatar', {
      class: _vm.getIconColor(key)
    }, [_c('v-icon', {
      attrs: {
        "dark": ""
      }
    }, [_vm._v(_vm._s(_vm.visualInfoItems[key].icon(_vm.getDetailsItem(key))))])], 1)], 1), _vm._v(" "), _c('div', [_c('p', {
      staticClass: "display-1 mb-0"
    }, [_vm._v("\n            " + _vm._s(_vm.getDetailsItem(key)) + "\n            "), (_vm.visualInfoItems[key].suf) ? _c('span', {
      staticClass: "title ma-0 ml-1"
    }, [_vm._v(_vm._s(_vm.visualInfoItems[key].suf))]) : _vm._e()]), _vm._v(" "), _c('p', {
      staticClass: "subheading ma-0"
    }, [_vm._v(_vm._s(_vm.visualInfoItems[key].label))]), _vm._v(" "), (key === 'application_rate' && _vm.getDetailsItem('accumulated_application_rate') !== '-') ? _c('p', [_c('span', {
      staticClass: "subheading ma-0",
      staticStyle: {
        "font-weight": "400"
      }
    }, [_vm._v(_vm._s(_vm.getDetailsItem('accumulated_application_rate')) + " " + _vm._s(_vm.$t("CardDetails.mmUnit")))]), _vm._v(" "), _c('span', {
      staticClass: "subheading ma-0"
    }, [_vm._v(_vm._s(_vm.$t("CardDetails.accumulated")))])]) : _vm._e()])])
  }), 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f871719e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Reports/CardDetails.vue
// module id = 1764
// module chunks = 0